import React, { useState, useEffect, useCallback, useRef } from "react"
import {
  Container,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  Input,
} from "reactstrap"

import "react-multi-carousel/lib/styles.css"

import classnames from "classnames"


import "react-toastify/dist/ReactToastify.css"

/* ─── helper: render the pill content for any question_status ─── */
function renderNavContent(question_status, label) {
  switch (question_status) {
    case 3: // Wrong — red number + red ✕
      return (
        <>
         <i className="mdi mdi-close-thick font-size-18" style={{ color: "#e53935" }}></i>
        </>
      )
    case 4: // Correct — green number + green ✓
      return (
        <>
          <i className="fas fa-check font-size-16" style={{ color: "#43a047" }}></i>
        </>
      )
    case 5: // Partial — orange number + orange ✓
      return (
        <>
         <i className="fas fa-check font-size-16" style={{ color: "#fb8c00" }}></i>
        </>
      )
    default: // 1 active, 2 upcoming, 6 skipped
      return (
        <span className="font-size-20 fw-bold">{label}</span>
      )
  }
}

/* ─── helper: resolve className for the NavLink pill ─── */
function resolveNavClass(question_status, isCurrentTab) {
  if (isCurrentTab) return " display-hold_active"
  switch (question_status) {
    case 1:  return " display-hold_active"
    case 2:  return " display-number"
    case 3:  return " display-attempt_fail"
    case 4:  return " display-attempt1"
    case 5:  return " display-attempt2"
    default: return " display-number"
  }
}

const Pagination = React.memo(
  ({
    ActivityData1,
    keyData,
    triggerSetActiveData,
    triggerSkipQuestionTotal,
      }) => {
    const [ActivityData, setActivityData] = useState([])
    //categoty 1 ,8
    const [ActiveData, setActiveData] = useState(null)
    const [ActivityPart, setActivityPart] = useState([])
    //const [IsFirstQuestion, setIsFirstQuestion] = useState(0);
    // const [IsLastQuestion, setIsLastQuestiont] = useState(0);

    const [customActiveTab, setcustomActiveTab] = useState("1")

    let active_state = 1
    let i = 0
    // return
    let IsFirstQuestion = useRef(0)
    let IsLastQuestion = useRef(0)

    let IsTotalTab = useRef(0)
    let IsCurrentTab = useRef(0)
    let IsCurrentTabTotalPart = useRef(0)
    let IsCurrentTabCurrentPart = useRef(0)

    let IsCurrentSkipQuestion = useRef(0)
    let ShowAllParts = useRef(false)

    useEffect(() => {
      if (ActivityData1 && ActivityData1 != "" && ActivityData1 != undefined) {
        //reset data
        setActivityData(ActivityData1)
        setActiveData(null)
        setActivityPart([])
        IsFirstQuestion.current = 0
        IsLastQuestion.current = 0

        IsTotalTab.current = 0
        IsCurrentTab.current = 0
        IsCurrentTabTotalPart.current = 0
        IsCurrentTabCurrentPart.current = 0

        IsCurrentSkipQuestion.current = 0
        ShowAllParts.current = false

        active_state = 1
        i = 0
      }
    }, [ActivityData1])
    //console.log(ActivityData);

    useEffect(() => {
      if (ActiveData != "" && IsLastQuestion.current !== 0) {
        //console.log(IsTotalTab.current);
        triggerSetActiveData({
          activeData: ActiveData,
          IsLastQuestion: IsLastQuestion.current,
          IsFirstQuestion: IsFirstQuestion.current,
          ActivityPartData: ActivityPart,
          IsTotalTab: IsTotalTab.current,
          IsCurrentTab: IsCurrentTab.current,
          IsCurrentTabTotalPart: IsCurrentTabTotalPart.current,
          IsCurrentTabCurrentPart: IsCurrentTabCurrentPart.current,
          IsCurrentSkipQuestion: IsCurrentSkipQuestion.current,
          ShowAllParts: ShowAllParts.current,
        })
      }
    }, [IsLastQuestion, IsFirstQuestion, ActiveData])

    useEffect(() => {
      triggerSkipQuestionTotal(IsCurrentSkipQuestion.current)
    }, [IsCurrentSkipQuestion.current])
    //console.log(ActivityData);

    return ActivityData && ActivityData.length > 0
      ? ActivityData.map((activity, index) => {
          IsCurrentSkipQuestion.current = activity.skip_question

          IsTotalTab.current = ActivityData.length
          if (
            activity.english_question &&
            activity.english_question.length > 0 &&
            parseInt(activity.fk_sub_id) === 1
          ) {
            return activity.english_question.map((question, index1) => {
              if (
                parseInt(question.english_question_category_id) === 1 ||
                parseInt(question.english_question_category_id) === 8 ||
                parseInt(question.english_question_category_id) === 2 ||
                parseInt(question.english_question_category_id) === 12
              ) {
                let filteredManualMark = question.english_question_parts.filter(
                  manualMark =>
                    parseInt(manualMark.english_question_part_automark) === 0
                )
                let question_status = 1
                const catId = parseInt(question.english_question_category_id, 10)
                const showAllParts = catId === 8 || catId === 2 || catId === 12

                if (
                  question.english_question_parts &&
                  question.english_question_parts.length > 0
                ) {
                  question.english_question_parts.forEach(
                    (activityQuestionPart, index2) => {
                      let partManualMark = parseInt(
                        activityQuestionPart.english_question_part_automark
                      )
                      i++
                      let total_mark = 0
                      const activateOnePart = () => {
                        question_status = 1
                        active_state = 0
                        IsFirstQuestion.current = i
                        IsCurrentTab.current = index + 1
                        IsCurrentTabTotalPart.current =
                          question.english_question_parts.length
                        IsCurrentTabCurrentPart.current = index2 + 1
                        if (ActiveData == null) {
                          setActiveData(activity)
                          setActivityPart([activityQuestionPart])
                        }
                      }
                      if (
                        activityQuestionPart.StudentAnsAttempts &&
                        activityQuestionPart.StudentAnsAttempts.length > 0
                      ) {
                        activityQuestionPart.StudentAnsAttempts.forEach(
                          stuAnswer => {
                            if (stuAnswer.points_obtained != null) {
                              total_mark += parseInt(stuAnswer.points_obtained)
                            }
                          }
                        )

                        if (
                          activityQuestionPart.StudentAnsAttempts.length >= 2 &&
                          total_mark === 0
                        ) {
                          question_status = 3
                        } else if (
                          activityQuestionPart.StudentAnsAttempts.length >= 1 &&
                          total_mark >= 2
                        ) {
                          question_status = 4
                        } else if (
                          activityQuestionPart.StudentAnsAttempts.length >= 2 &&
                          total_mark > 0
                        ) {
                          question_status = 5
                        } else if (
                          activityQuestionPart.StudentAnsAttempts.length ===
                            1 &&
                          total_mark >= 0 &&
                          partManualMark <= 0
                        ) {
                          question_status = 2
                        } else if (
                          activityQuestionPart.StudentQusSkip.length > 0
                        ) {
                          question_status = 6
                        } else if (parseInt(active_state) === 1) {
                          activateOnePart()
                        } else {
                          question_status = 2
                        }
                      } else if (
                        activityQuestionPart.StudentQusSkip.length > 0
                      ) {
                        question_status = 6
                      } else if (parseInt(active_state) === 1) {
                        activateOnePart()
                      } else {
                        question_status = 2
                      }
                    }
                  )
                }
                IsLastQuestion.current = i

                const isCurrentTab = IsCurrentTab.current === index + 1
                const label = filteredManualMark.length > 0 ? "M" : index + 1

                return (
                  <NavItem key={index}>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={
                        classnames({ active: customActiveTab === index + 1 }) +
                        resolveNavClass(question_status, isCurrentTab)
                      }
                    >
                      {isCurrentTab
                        ? <span className="font-size-20 fw-bold">{label}</span>
                        : renderNavContent(question_status, label)
                      }
                    </NavLink>
                  </NavItem>
                )
              } else if (
                parseInt(question.english_question_category_id) === 13 ||
                parseInt(question.english_question_category_id) === 10
              ) {
                let filteredManualMark = question.english_question_parts.filter(
                  manualMark =>
                    parseInt(manualMark.english_question_part_automark) === 0 &&
                    manualMark.english_question_answers &&
                    manualMark.english_question_answers.length > 0 &&
                    manualMark.english_question_answers[0]
                      .english_answer_text &&
                    manualMark.english_question_answers[0]
                      .english_answer_text != ""
                )
                let question_status = 1

                if (
                  question.english_question_parts &&
                  question.english_question_parts.length > 0
                ) {
                  let array_part_data = question.english_question_parts
                    .map((part, originalIndex) => ({ part, originalIndex }))
                    .filter(
                      ({ part }) =>
                        part.english_question_answers.length > 0 &&
                        part.english_question_answers[0].english_answer_text &&
                        part.english_question_answers[0].english_answer_text !=
                          ""
                    )

                  array_part_data.forEach(
                    (
                      { part: activityQuestionPart, originalIndex },
                      filteredIndex
                    ) => {
                      let partManualMark = parseInt(
                        activityQuestionPart.english_question_part_automark
                      )
                      i++
                      let total_mark = 0
                      const activateWritingOne = () => {
                        question_status = 1
                        active_state = 0
                        IsFirstQuestion.current = i
                        IsCurrentTab.current = index + 1
                        IsCurrentTabTotalPart.current = array_part_data.length
                        IsCurrentTabCurrentPart.current = originalIndex + 1
                        if (ActiveData == null) {
                          setActiveData(activity)
                          setActivityPart([activityQuestionPart])
                        }
                      }
                      if (
                        activityQuestionPart.StudentAnsAttempts &&
                        activityQuestionPart.StudentAnsAttempts.length > 0
                      ) {
                        activityQuestionPart.StudentAnsAttempts.forEach(
                          stuAnswer => {
                            if (stuAnswer.points_obtained != null) {
                              total_mark += parseInt(stuAnswer.points_obtained)
                            }
                          }
                        )

                        if (
                          activityQuestionPart.StudentAnsAttempts.length >= 2 &&
                          total_mark === 0
                        ) {
                          question_status = 3
                        } else if (
                          activityQuestionPart.StudentAnsAttempts.length >= 1 &&
                          total_mark >= 2
                        ) {
                          question_status = 4
                        } else if (
                          activityQuestionPart.StudentAnsAttempts.length >= 2 &&
                          total_mark > 0
                        ) {
                          question_status = 5
                        } else if (
                          activityQuestionPart.StudentAnsAttempts.length ===
                            1 &&
                          total_mark >= 0 &&
                          partManualMark <= 0
                        ) {
                          question_status = 2
                        } else if (
                          activityQuestionPart.StudentQusSkip.length > 0
                        ) {
                          question_status = 6
                        } else if (parseInt(active_state) === 1) {
                          activateWritingOne()
                        } else {
                          question_status = 2
                        }
                      } else if (
                        activityQuestionPart.StudentQusSkip.length > 0
                      ) {
                        question_status = 6
                      } else if (parseInt(active_state) === 1) {
                        activateWritingOne()
                      } else {
                        question_status = 2
                      }
                    }
                  )
                }
                IsLastQuestion.current = i

                const isCurrentTab = IsCurrentTab.current === index + 1
                const label = filteredManualMark.length > 0 ? "M" : index + 1

                return (
                  <NavItem key={index}>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={
                        classnames({ active: customActiveTab === index + 1 }) +
                        resolveNavClass(question_status, isCurrentTab)
                      }
                    >
                      {isCurrentTab
                        ? <span className="font-size-20 fw-bold">{label}</span>
                        : renderNavContent(question_status, label)
                      }
                    </NavLink>
                  </NavItem>
                )
              }
            })

            // }
          } else if (
            activity.question &&
            activity.question.length > 0 &&
            parseInt(activity.fk_sub_id) === 2
          ) {
            //maths
            return activity.question.map((question, index1) => {
              // console.log('enter2')
              if (question.question_id != null) {
                let filteredManualMark = []
                //let filteredManualMark = question.question_parts.filter(manualMark => ((parseInt(manualMark.english_question_part_automark) === 0)))
                let question_status = 1

                // console.log(active_state)
                if (
                  question.question_parts &&
                  question.question_parts.length > 0
                ) {
                  //let total_coins = question.english_question_parts.length * 2;
                  //setTotalCoins(prevTotalCoins => prevTotalCoins + total_coins);
                  question.question_parts.forEach(
                    (activityQuestionPart, index2) => {
                      //let partManualMark = parseInt(activityQuestionPart.english_question_part_automark);
                      i++
                      let total_mark = 0
                      if (
                        activityQuestionPart.StudentAnsAttempts &&
                        activityQuestionPart.StudentAnsAttempts.length > 0
                      ) {
                        activityQuestionPart.StudentAnsAttempts.forEach(
                          (stuAnswer, index3) => {
                            if (stuAnswer.points_obtained != null) {
                              total_mark += parseInt(stuAnswer.points_obtained) // Increment count_answer by 1 for each occurrence
                            }
                          }
                        )

                        if (
                          activityQuestionPart.StudentAnsAttempts.length >= 2 &&
                          total_mark === 0
                        ) {
                          question_status = 3
                        } else if (
                          activityQuestionPart.StudentAnsAttempts.length >= 1 &&
                          total_mark >= 2
                        ) {
                          question_status = 4
                        } else if (
                          activityQuestionPart.StudentAnsAttempts.length >= 2 &&
                          total_mark > 0
                        ) {
                          question_status = 5

                          // }else if(activityQuestionPart.StudentAnsAttempts.length ===1 && total_mark >= 0 && partManualMark <= 0){
                          //   question_status = 2;
                        } else if (
                          activityQuestionPart.StudentQusSkip.length > 0
                        ) {
                          // skip question
                          question_status = 6
                        } else {
                          if (parseInt(active_state) === 1) {
                            // console.log('active')
                            question_status = 1
                            active_state = 0
                            IsFirstQuestion.current = i
                            IsCurrentTab.current = index + 1
                            IsCurrentTabTotalPart.current =
                              question.question_parts.length
                            IsCurrentTabCurrentPart.current = index2 + 1
                            //setIsFirstQuestion(i);
                            if (ActiveData == null) {
                              // setActiveData(activityQuestionPart);
                              setActiveData(activity)
                              setActivityPart([activityQuestionPart])
                            }
                          } else {
                            question_status = 2
                          }
                        }
                      } else if (
                        activityQuestionPart.StudentQusSkip.length > 0
                      ) {
                        // skip question
                        question_status = 6
                      } else {
                        if (parseInt(active_state) === 1) {
                          question_status = 1
                          active_state = 0

                          // setIsFirstQuestion(i);
                          IsFirstQuestion.current = i
                          IsCurrentTab.current = index + 1
                          IsCurrentTabTotalPart.current =
                            question.question_parts.length
                          IsCurrentTabCurrentPart.current = index2 + 1
                          if (ActiveData == null) {
                            // setActiveData(activityQuestionPart);
                            setActiveData(activity)
                            setActivityPart([activityQuestionPart])
                          }
                        } else {
                          question_status = 2
                        }
                      }
                      // console.log('status -'+i+' - '+question_status);
                    }
                  )
                }
                IsLastQuestion.current = i
                //setIsLastQuestiont(i);

                const isCurrentTab = IsCurrentTab.current === index + 1
                const label = filteredManualMark.length > 0 ? "M" : index + 1

                return (
                  <NavItem key={index}>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={
                        classnames({ active: customActiveTab === index + 1 }) +
                        resolveNavClass(question_status, isCurrentTab)
                      }
                    >
                      {isCurrentTab
                        ? <span className="font-size-20 fw-bold">{label}</span>
                        : renderNavContent(question_status, label)
                      }
                    </NavLink>
                  </NavItem>
                )
              }
            })
          } else {
            //else
          }
        })
      : null
  }
)

export default Pagination